{
  "FormEngineSelectElement": {
    "title": "Wählen"
  },
  "mask": {
    "FormEngineSelectElement": {
      "groupTitle": "Wählen",
      "datasource": "Optionen",
      "datasourceExpressions": "Optionsfilter",
      "showError": "Fehler anzeigen",
      "showDefaultOption": "Standardoption anzeigen",
      "defaultOptionLabel": "Bezeichnung der Standardoption",
      "defaultOptionLabelPlaceholder": "Wählen…",
      "searchable": "Durchsuchbar",
      "placeholder": "Platzhalter",
      "controlType": "Darstellung",
      "controlTypes": {
        "native": "Nativ",
        "advanced": "Erweitert"
      }
    }
  }
}